import { useEffect, useMemo, useRef, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import {
  add,
  error,
  errorinvoice,
  externalName,
  failedMsg,
  labConstant,
  labModule,
  LabOrder,
  LabTests,
  lmsIntent,
  LmstableHeading,
  LoadPrice,
  NewOrder,
  opd,
  optionValue,
  OrderEvent,
  orderMsg,
  orderSubmit,
  orderSucess,
  orderValidationmsg,
  paid,
  Panel,
  priceFailedMsg,
  PriceList,
  priceListNotFound,
  Row,
  success,
} from './models'
import { LABS_PROJECT_ID, RADIOLOGY_PROJECT_ID } from '../../utils/constants'
import { toast } from 'react-toastify'
import ToastMessage from '../lms/components/ToastMessage'
import { ORDERED, toastOptions } from '../lms/models'
import { getDoctorForVisit, saveOrder } from './utils'
import KeycloakService from '../../utils/keycloakService'
import { LAB_ORDERS_WRITE } from '../../utils/roles'
import { useAppDispatch, useAppSelector } from '../../app/hooks'
import {
  selectLocationById,
  selectSelectedLocationId,
} from '../location/locationSlice'
import { prepareOrderEventTests } from '../lms/utils'
import { readableDateTimeFormat } from '../../utils/dateUtils'
import Select from 'react-select'
import { Doctor } from '../scheduler/schedulerSlice'
import { fetchSlotsDoctorsAsync, selectSlotsDoctors } from '../slots/slotsSlice'
import { setQueryParam } from '../membership/membershipSlice'
import {
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useTheme,
} from '@mui/material'
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined'
import {
  labDashboard,
  labordercreate,
  orderinvoice,
  visits,
} from '../bedManagement/endpoints/EndPoints'
import {
  CreateLabInvoice,
  generateGlobalId,
  getAllRadiologyTestsApi,
  getLabOrdersByVisitId,
  getOdooProductPrice,
  getRadiologyOrdersForPatientForOpd,
  getRadiologyOrdersByVisitId,
  getVisitByEncounterId,
  UpdateLabInvoice,
  updatedOrderEventByOrderId,
} from '../../services/LmsService'
import PackageTests from './PackageTests'
import { setLmsDateFilter, setLmsActiveTab } from '../lms/lmsSlice'
import { noLrGeneration, patientConstants } from '../lms/constants'
import { useLabOrganizations } from '../lms/components/search/useLabOrganizations'
import {
  saveRadiologyOrderFromLab,
  transformData,
  createOrUpdateInvoice,
} from '../Radiology/Utils/utils'
import { startSxpProxy } from '../../utils/api'
import './labs.scss'
import './OPDOrders.css'
import { radiologyText, unpaid } from '../OPDScreen/constant'
import { OPD_ORDERS_CONSTANTS } from './opdOrdersConstants'
import { fetchRadiologyTestPrice } from '../../services/RadiologyService'
import { B2BOrderValue } from '../administration/constants'
import { DECISION_OPTIONS } from '../bedManagement/IpdVisit/IpdSummary/InitialAssessment/Constants'
import {
  radiology,
  radiologyIntents,
  selectTests,
} from '../Radiology/Constants/constants'
import {
  OpdRadiologyRow,
  RadiologyLabTest,
  RadiologyOrders,
} from '../Radiology/models'
import { setRadiologyActiveTab } from '../Radiology/RadiologySlice'
import useCustomStyles from '../../utils/hooks/CustomStylesHook'
const styles = () => ({
  tableScrollContainer: {
    overflow: 'auto',
  },
  tableWrapper: {
    height: '100%',
    overflow: 'auto',
  },
  tableContainer: {
    maxHeight: '100%',
    overflow: 'auto',
    '& .MuiTableHead-root .MuiTableCell-root': {
      backgroundColor: '#4682b4',
      color: 'white',
      fontWeight: 600,
      fontSize: '12px',
      padding: '12px 8px',
      whiteSpace: 'nowrap',
      borderBottom: '1px solid rgba(255,255,255,0.6)',
      borderRight: '1px solid rgba(255,255,255,0.4)',
      '&:last-child': {
        borderRight: 'none',
      },
    },
    '& .MuiTableBody-root .MuiTableRow-root': {
      borderBottom: '1px solid #e5e7eb',
      '&:hover': { backgroundColor: 'rgba(70, 130, 180, 0.05)' },
    },
    '& .MuiTableBody-root .MuiTableCell-root': {
      padding: '10px 8px',
      fontSize: '13px',
      verticalAlign: 'middle',
      borderBottom: '1px solid #e5e7eb',
      borderRight: '1px solid #e5e7eb',
      '&:last-child': {
        borderRight: 'none',
      },
    },
    '& .MuiTableCell-root.price-cell': {
      textAlign: 'right',
      paddingRight: '12px',
      fontWeight: 500,
    },
  },
  colSlNo: {
    minWidth: 45,
  },
  colDate: {
    minWidth: 85,
  },
  colMode: {
    minWidth: 100,
  },
  colOrigin: {
    minWidth: 100,
  },
  colRequestedBy: {
    minWidth: 140,
  },
  colTestName: {
    minWidth: 200,
  },
  colParamTests: {
    minWidth: 150,
  },
  colQuantity: {
    minWidth: 60,
  },
  colPrice: {
    minWidth: 80,
  },
  colDiscount: {
    minWidth: 75,
  },
  colSubtotal: {
    minWidth: 80,
  },
  colAction: {
    minWidth: 60,
  },
})
interface OpdOrderProps {
  patient: any
  id?: string
  isPatientView?: boolean
}
const OpdOrder: React.FC<OpdOrderProps> = ({
  patient,
  id: prodId,
  isPatientView,
}) => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)
  const { id: routeId }: any = useParams()
  const id = prodId ?? routeId
  const patientUhid = patient?.identifier?.find(
    (id: any) => id?.system == patientConstants?.patientIdentifier
  )?.value
  const [newrowadded, setNewRowAdded] = useState(false)
  const [patientId, setPatientId] = useState('')
  const [order, setOrder] = useState<LabOrder>({})
  const [orders, setOrders] = useState<LabOrder[]>([])
  const [activeIndex, setActiveIndex] = useState(-1)
  const [origin, setOrigin] = useState(OPD_ORDERS_CONSTANTS.ORIGIN_OPD)
  const locationId = useAppSelector(selectSelectedLocationId)
  const location = useAppSelector((state) =>
    selectLocationById(locationId, state)
  )
  const [selectedTests, setSelectedTests] = useState<any[]>([])
  const [rows, setRows] = useState<Row[]>([])
  const [ordersEvent, setOrdersEvent] = useState<OrderEvent[]>([])
  const [isRowAdded] = useState(false)
  const [testAdded, setTestAdded] = useState(false)
  const [radiologyOrders, setRadiologyOrders] = useState<RadiologyOrders[]>([])
  const [radiologyOrder, setRadiologyOrder] = useState<RadiologyOrders>({})
  const [radiologyRows, setRadiologyRows] = useState<OpdRadiologyRow[]>([])
  const VisitTableRef = useRef<HTMLDivElement | null>(null)
  const [orderType, setOrderType] = useState<'lab' | 'radiology'>('lab')
  const [radiologyNewRow, setRadiologyNewRow] = useState<OpdRadiologyRow>({
    mode: { label: 'Radiology', value: 'radiology' },
    requestedBy: null,
    sampleName: null,
    testName: null,
    origin: null,
    packageName: null,
    packageTests: null,
    price: 0,
    discount: 0,
  })
  const [radiologyTestNameOptions, setRadiologyTestNameOptions] = useState<
    any[]
  >([])
  const [radiologyTestAdded, setRadiologyTestAdded] = useState(false)
  const navigate = useNavigate()
  const [testNameOptions, setTestNameOptions] = useState<
    { label: string; value: string; panels: any; odoo_testId: any }[]
  >([])
  const [radiologyTestOptions, setRadiologyTestOptions] = useState<
    {
      label: string
      value: string
      sampleId: any
      sampleName: string
      odoo_test_id: any
    }[]
  >([])
  const [visitStatus, SetVisitStatus] = useState('')
  const [newRow, setNewRow] = useState<Row>({
    mode: null,
    requestedBy: null,
    sampleName: null,
    testName: null,
    panel: null,
    origin: null,
    price: 0,
    panels: null,
    packagePrice: 0,
    OdooPackageId: 0,
    productName: '',
    discount: 0,
  })
  const [isSaving, setIsSaving] = useState(false)
  const [priceLoading, setPriceLoading] = useState(false)
  const [externalText, setExternalText] = useState('')
  const [lrNumber, setLrNumber] = useState('')
  const reqPatnerId = newRow?.requestedBy?.odooId
  const dispatch = useAppDispatch()
  const handleModeChange = (selectedOption: any) => {
    setRows([])
    setRadiologyRows([])
    setOrderType(
      selectedOption?.value === radiologyText ? radiologyText : labConstant
    )
    if (selectedOption?.value === radiologyText) {
      setRadiologyNewRow((prev: any) => ({
        ...prev,
        mode: selectedOption,
        sampleName: null,
        testName: null,
        packageName: null,
        packageTests: null,
        price: 0,
        discount: 0,
      }))

      setNewRowAdded(true)
      return
    }
    if (
      selectedOption?.value === optionValue?.test?.value ||
      selectedOption?.value === optionValue?.package?.value
    ) {
      setNewRow((prev: any) => ({
        ...prev,
        mode: selectedOption,
        panels: [],
        testName: null,
        packageId: null,
        packageName: '',
        packagePrice: 0,
        OdooPackageId: null,
        allPanelNames: '',
        sampleName: null,
        price: 0,
        discount: 0,
      }))
      setNewRowAdded(true)
      return
    }
    setNewRowAdded(true)
    if (selectedOption?.value === OPD_ORDERS_CONSTANTS.MODE_RADIOLOGY) {
      fetchRadiologyTests()
    }
  }
  const fetchRadiologyTests = async () => {
    const response = await getAllRadiologyTestsApi()
    if (response?.length > 0) {
      const selectedTestLabels = rows.map((row) => row.testName?.label)
      const filteredTests = response?.filter(
        (test: any) => !selectedTestLabels.includes(test?.label)
      )
      setRadiologyTestOptions(filteredTests)
    } else {
      setRadiologyTestOptions([])
    }
  }
  const handleRadiologyTestChange = async (selectedOption: any) => {
    if (!selectedOption) return

    const updatedRow: any = {
      testName: {
        label: selectedOption?.label,
        value: selectedOption?.value,
        odoo_test_id: selectedOption?.odoo_test_id,
      },
      sampleName: {
        label: selectedOption?.sampleName,
        value: selectedOption?.sampleId,
      },
    }

    const priceList = location?.resource?.type?.[0]?.coding?.find(
      (item: any) => item.code === PriceList
    )?.display

    setPriceLoading(true)
    const b2bOrigin = origin === optionValue?.b2b?.value
    const reqDoctorRef = newRow?.requestedBy?.doctorRef

    const result = await fetchRadiologyTestPrice({
      locationResourceId: location?.resource?.id,
      patientId: id,
      odooTestId: selectedOption?.odoo_test_id,
      priceList,
      b2bOrigin,
      reqPatnerId,
      reqDoctorRef,
    })

    setPriceLoading(false)

    if (result.success && result.data) {
      const { price, defaultPrice, pricelistId, discount } = result.data
      updatedRow.price = price
      updatedRow.discount = discount
      updatedRow.defaultPrice = defaultPrice
      updatedRow.panel = {
        ...updatedRow.testName,
        price,
        discount,
        defaultPrice,
        pricelist_id: pricelistId,
        best_price: price,
      }
      setNewRow((prev) => ({ ...prev, ...updatedRow }))
    } else {
      const errorMsg = result.error || priceFailedMsg
      toast(<ToastMessage message={errorMsg} />, {
        ...toastOptions,
        type: error,
      })
    }
  }
  const executeFunction = () => {
    const state = {}
    startSxpProxy(
      LABS_PROJECT_ID,
      OPD_ORDERS_CONSTANTS.INTENT_GET_ALL_PANELS,
      state
    )
      ?.then((data) => {
        const panelData: any = data?.data?.panel ?? []
        const tests = panelData?.map((test: any) => ({
          label: test?.name,
          value: String(test?.id),
          odoo_test_id: test?.odoo_test_id,
          sampleName: test?.sample?.name,
          sampleId: test?.sample?.id,
          panel: {
            name: test?.name,
            description: test?.description,
            id: test?.id,
            odoo_test_id: test?.odoo_test_id,
            lab_tests: test?.lab_tests,
            sampleId: parseInt(test?.sample?.value),
            sampleName: test?.sample?.name,
            processing_unit: '',
            price: test?.price ?? 0,
          },
        }))
        const selectedTestLabels = rows.map((row) => row.testName?.label)
        const filteredTests = tests.filter(
          (test: any) => !selectedTestLabels.includes(test.label)
        )
        setTestNameOptions(filteredTests)
      })
      .catch((error) => {
        console.error('Error fetching test names:', error)
        setTestNameOptions([])
      })
  }
  const handleTestNameChange = async (selectedOption: any) => {
    if (!selectedOption) return
    const updatedRow: any = {
      testName: {
        label: selectedOption?.label,
        value: selectedOption?.value,
        odoo_test_id: selectedOption?.odoo_test_id,
      },
      sampleName: {
        label: selectedOption?.panel?.sampleName,
        value: selectedOption?.panel?.sampleId,
      },
      panel: selectedOption?.panel,
    }

    const priceList = location?.resource?.type?.[0]?.coding?.find(
      (item: any) => item.code === PriceList
    )?.display
    setPriceLoading(true)
    const b2bOrigin = origin === 'B2B'
    const reqDoctorRef = newRow?.requestedBy?.doctorRef
    try {
      const response = await getOdooProductPrice({
        selectedLocationId: location?.resource?.id,
        patient_identifier: id,
        partner_id: newRow?.requestedBy?.odooId || '',
        odootestid:
          selectedOption?.panel?.odoo_test_id || selectedOption?.OdooPackageId,
        pricelist_id: priceList,
        b2b: b2bOrigin,
        reqOdooId: reqPatnerId || '',
        doctor_id: reqDoctorRef || '',
      })

      const rawPrice =
        response?.data?.best_price ?? response?.data?.data?.best_price ?? 0
      const defaultPrice = response?.data?.default_price ?? 0
      const price = Number(rawPrice)
      const pricelistId = response?.data?.pricelist_id
      const discount =
        response?.data?.discount_percent ??
        response?.data?.data?.discount_percent ??
        0
      if (!Number?.isFinite(price)) {
        throw new Error(priceListNotFound)
      }
      updatedRow.price = price
      updatedRow.discount = discount
      updatedRow.defaultPrice = defaultPrice
      updatedRow.panel = {
        ...updatedRow.panel,
        price,
        discount,
        defaultPrice,
        pricelist_id: pricelistId,
        best_price: price,
      }
      setNewRow((prev) => ({ ...prev, ...updatedRow }))
    } catch (e: any) {
      const errorMsg = e?.response?.data?.message || priceFailedMsg
      toast(<ToastMessage message={errorMsg} />, {
        ...toastOptions,
        type: error,
      })
    } finally {
      setPriceLoading(false)
    }
  }
  const products = rows
    ?.map((row: any) => ({
      product_id:
        row?.panel?.odoo_test_id || row?.OdooPackageId || order?.package_id,
      price: row?.panel?.defaultPrice ?? 0,
      discount_percent: row?.panel?.discount ?? 0,
      pricelist_id: row?.panel?.pricelist_id ?? null,
      best_price: row?.panel?.best_price ?? row?.panel?.price ?? 0,
    }))
    ?.filter((e: any) => e?.product_id)

  const generationGlobalId = async () => {
    const resp = await generateGlobalId()
    if (!resp?.response?.id || resp?.response?.id === '') {
      toast?.error(noLrGeneration)
      return
    } else {
      setLrNumber(resp?.response?.id)
    }
  }

  // Determine if LR number generation is needed for radiology orders
  const shouldGenerateLrNumber = useMemo(() => {
    // Skip if LR number already exists or editing existing order
    if (lrNumber || radiologyOrder?.id) return false

    // Check for new radiology order with tests
    const isNewRadiologyOrder =
      orderType === radiologyText && radiologyRows?.length > 0

    // Check for lab order containing radiology tests
    const hasRadiologyTests = rows?.some(
      (row) => row?.mode?.value === OPD_ORDERS_CONSTANTS.MODE_RADIOLOGY
    )

    return isNewRadiologyOrder || hasRadiologyTests
  }, [orderType, radiologyRows?.length, rows, lrNumber, radiologyOrder?.id])

  // Generate LR number when needed
  useEffect(() => {
    if (shouldGenerateLrNumber) {
      generationGlobalId()
    }
  }, [shouldGenerateLrNumber])
  const isRadiologyOperation = () => {
    if (
      orderType === radiologyText ||
      rows?.some(
        (row) => row?.mode?.value === OPD_ORDERS_CONSTANTS.MODE_RADIOLOGY
      )
    ) {
      return true
    }
    return false
  }

  // Process radiology tests and packages
  const processRadiologyTests = (radiologyRows: OpdRadiologyRow[]) => {
    // Process individual test rows
    const filteredPanels = radiologyRows
      ?.filter((row) => row?.mode?.value === radiologyText)
      ?.map((row) => ({
        sampleName: row?.sampleName?.label,
        sampleId: row?.sampleName?.value,
        testName: row?.testName?.label,
        testId: row?.testName?.value,
        isTestSelect: true,
        packageId: null,
        price: row?.price || null,
        discount: Number(row?.discount?.toFixed(2)) ?? 0,
        defaultPrice: row?.defaultPrice || null,
      }))
    // Process package rows
    const packageResult: any[] = []
    radiologyRows
      ?.filter((row) => row?.mode?.value === 'package')
      ?.forEach((row) => {
        const packageId = row?.packageTests?.packageId
        if (packageId === undefined) return

        row?.packageTests?.radiology_lab_tests?.forEach(
          (test: RadiologyLabTest) => {
            const existingTest = packageResult?.find(
              (item) => Number(item?.testId) === Number(test?.testId)
            )
            if (existingTest) {
              existingTest.packageId?.push(packageId)
            } else {
              packageResult.push({
                testId: Number(test?.testId),
                sampleId: test?.sampleId,
                testName: test?.testName,
                sampleName: test?.sampleName,
                isTestSelect: false,
                packageId: [packageId],
              })
            }
          }
        )
      })

    const packageIds = [
      ...new Set(
        packageResult?.flatMap((item) => item?.packageId)?.filter(Boolean)
      ),
    ]
    const combinedResult = [...filteredPanels, ...packageResult]
    const totalPrice = radiologyRows?.reduce(
      (sum, row) => sum + (row?.price || 0),
      0
    )

    return { combinedResult, packageIds, totalPrice }
  }

  // Build Odoo product list for radiology
  const buildRadiologyProducts = (
    radiologyRows: OpdRadiologyRow[],
    radiologyOrder: RadiologyOrders
  ) => {
    const radiologyOdooTestIds = radiologyRows
      ?.map((row: any) => ({
        product_id:
          row?.panel?.odoo_test_id ||
          row?.OdooPackageId ||
          radiologyOrder?.package_id ||
          row?.testName?.odoo_test_id,
        price: row?.panel?.defaultPrice || row?.packagePrice || row?.price,
        discount_percent: row?.panel?.discount || row?.discount || 0,
      }))
      ?.filter(
        (e: any) => e?.product_id !== null && e?.product_id !== undefined
      )

    return radiologyOdooTestIds?.reduce(
      (
        acc: any[],
        item: {
          discount_percent: any
          product_id: number
          price: number
        }
      ) => {
        const existing = acc?.find(
          (entry) => entry?.product_id === item?.product_id
        )
        if (existing) {
          existing.quantity += 1
        } else {
          acc?.push(
            radiologyOrder?.origin === optionValue?.b2b?.value
              ? {
                  product_id: item?.product_id,
                  product_uom_qty: 1,
                  order_ref: radiologyOrder?.ref_id,
                  patient_id: item?.product_id,
                  price: item?.price,
                  discount_percent:
                    Number(item?.discount_percent?.toFixed(2)) ?? 0,
                }
              : {
                  product_id: item?.product_id,
                  quantity: 1,
                  price: item?.price,
                  discount_percent:
                    Number(item?.discount_percent?.toFixed(2)) ?? 0,
                }
          )
        }
        return acc
      },
      []
    )
  }

  // Handle radiology order save operation
  const handleRadiologyOrderSave = async () => {
    // Validation
    if (!radiologyRows?.length) {
      toast(<ToastMessage message='Please add at least one radiology test' />, {
        ...toastOptions,
        type: error,
      })
      return false
    }

    setIsSaving(true)

    try {
      const mode: 'visit' | 'patient' = locations.pathname.startsWith(visits)
        ? OPD_ORDERS_CONSTANTS.TYPE_VISIT
        : OPD_ORDERS_CONSTANTS.TYPE_PATIENT
      const locationName = location?.resource?.name ?? ''
      const locationResourceId = location?.resource?.id ?? ''
      const requestedBy = locations?.pathname?.startsWith(visits)
        ? await getDoctorForVisit(id ?? '')
        : radiologyRows?.[radiologyRows?.length - 1]?.requestedBy?.value

      // Process tests and packages
      const { combinedResult, packageIds, totalPrice } =
        processRadiologyTests(radiologyRows)
      const radiologyProducts = buildRadiologyProducts(
        radiologyRows,
        radiologyOrder
      )
      // Create or update invoice
      let radiologyInvoiceResponse = null
      if (
        locations.pathname.startsWith(labordercreate) &&
        origin !== optionValue?.others?.value &&
        origin !== optionValue?.ipd?.value
      ) {
        const reqOdooId =
          radiologyRows?.[radiologyRows?.length - 1]?.requestedBy?.odooId
        const reqDoctorRef =
          radiologyRows?.[radiologyRows?.length - 1]?.requestedBy?.doctorRef

        radiologyInvoiceResponse = await createOrUpdateInvoice(
          origin,
          radiologyProducts,
          radiologyOrder,
          patientUhid,
          reqOdooId,
          reqDoctorRef,
          radiologyRows,
          locationResourceId,
          setIsSaving
        )

        if (
          !radiologyInvoiceResponse ||
          radiologyInvoiceResponse?.data?.odooApistatus ===
            OPD_ORDERS_CONSTANTS.ODOO_API_STATUS_ERROR
        ) {
          const response = radiologyInvoiceResponse?.data
          toast(
            <ToastMessage
              message={response?.message || 'Failed to create invoice'}
            />,
            { ...toastOptions, type: error }
          )
          setIsSaving(false)
          return false
        }
      }

      const odooInvoiceID =
        radiologyInvoiceResponse?.data?.odoo_invoice_id ??
        radiologyInvoiceResponse?.data?.result?.document_id ??
        radiologyOrder?.odoo_invoice_id ??
        null
      const RefID =
        radiologyInvoiceResponse?.data?.ref_id ?? radiologyOrder?.ref_id ?? null
      await saveRadiologyOrderFromLab(
        mode,
        radiologyOrder,
        id,
        patientId || id,
        patientUhid,
        lrNumber,
        combinedResult,
        [],
        locationName,
        radiologyRows?.[0]?.packageTests?.packageId ?? 0,
        totalPrice,
        requestedBy,
        origin,
        packageIds,
        combinedResult,
        odooInvoiceID,
        RefID,
        locationResourceId,
        origin === optionValue?.others?.value ? paid : unpaid
      )

      toast(
        <ToastMessage
          message={
            radiologyOrder?.id
              ? 'Radiology order updated successfully'
              : 'Radiology order created successfully'
          }
        />,
        {
          ...toastOptions,
          type: success,
        }
      )

      // Navigation based on origin
      !isPatientView &&
        setTimeout(() => {
          if (locations?.pathname?.startsWith(labordercreate)) {
            if (
              radiologyOrder?.origin?.toLowerCase() === opd ||
              origin?.toLowerCase() === opd ||
              origin === optionValue?.b2b?.value
            ) {
              navigate(orderinvoice)
            } else {
              dispatch(setRadiologyActiveTab('testing'))
              navigate('/radiology')
            }
          }
        }, OPD_ORDERS_CONSTANTS.TOAST_TIMEOUT)

      // Refresh radiology orders
      fetchRadiologyTests()
      setRadiologyRows([])
      setRadiologyOrder({})
      setLrNumber('')
      setNewRowAdded(false)
      return true
    } catch (err: any) {
      toast(
        <ToastMessage
          message={err?.message || 'Error saving radiology order'}
        />,
        {
          ...toastOptions,
          type: error,
        }
      )
      return false
    } finally {
      setIsSaving(false)
    }
  }

  // Handle lab order save operation
  const handleLabOrderSave = async () => {
    // Validation
    if (!rows?.[0]?.testName) {
      toast(<ToastMessage message={orderValidationmsg} />, {
        ...toastOptions,
        type: error,
      })
      return false
    }

    setIsSaving(true)

    try {
      // Separate lab and radiology tests
      const labRows = rows.filter(
        (row) => row?.mode?.value !== OPD_ORDERS_CONSTANTS.MODE_RADIOLOGY
      )
      const radiologyTestRows = rows.filter(
        (row) => row?.mode?.value === OPD_ORDERS_CONSTANTS.MODE_RADIOLOGY
      )

      const filteredPanels: Panel[] = rows?.flatMap((row: Row) =>
        row?.mode?.value === OPD_ORDERS_CONSTANTS.MODE_TEST
          ? [row?.panel]
          : row?.panels || []
      )
      const filteredLabTests: any = []
      const mode: 'visit' | 'patient' = locations.pathname.startsWith(visits)
        ? OPD_ORDERS_CONSTANTS?.TYPE_VISIT
        : OPD_ORDERS_CONSTANTS?.TYPE_PATIENT
      const doctorName = await getDoctorForVisit(id ?? '')
      const locationName = location?.resource?.name ?? ''
      const locationResourceId = location?.resource?.id ?? ''
      const locationId = location?.resource?.id
      const requestedBy = locations?.pathname?.startsWith(visits)
        ? doctorName
        : rows?.[rows?.length - 1]?.requestedBy?.value ===
          optionValue?.external?.value
        ? externalText
        : rows?.[rows?.length - 1]?.requestedBy?.value
      const reqOdooId = rows?.[rows?.length - 1]?.requestedBy?.odooId
      const reqDoctorRef = rows?.[rows?.length - 1]?.requestedBy?.doctorRef
      const packageId = rows?.[rows?.length - 1]?.packageId

      // Build Odoo test IDs
      const odooTestIds = rows
        ?.map((row: any) => ({
          product_id:
            row?.panel?.odoo_test_id || row?.OdooPackageId || order?.package_id,
          price: row?.panel?.price || row?.packagePrice,
          discount_percent: row?.panel?.discount || row?.discount,
        }))
        ?.filter(
          (e: any) => e?.product_id !== null && e?.product_id !== undefined
        )

      const updatedTestIds = odooTestIds?.reduce(
        (acc: any[], item: { product_id: number; price: number }) => {
          const existing = acc?.find(
            (entry) => entry?.product_id === item?.product_id
          )
          if (existing) {
            existing.quantity += OPD_ORDERS_CONSTANTS.QUANTITY_DEFAULT
          } else {
            acc?.push(
              order?.origin === optionValue?.b2b?.value
                ? {
                    product_id: item?.product_id,
                    product_uom_qty: OPD_ORDERS_CONSTANTS.QUANTITY_DEFAULT,
                    order_ref: order?.ref_id,
                    patient_id: item?.product_id,
                  }
                : {
                    product_id: item?.product_id,
                    quantity: OPD_ORDERS_CONSTANTS.QUANTITY_DEFAULT,
                  }
            )
          }
          return acc
        },
        []
      )

      // Create or update invoice
      let invoiceResponse = null
      if (locations?.pathname?.startsWith(labordercreate)) {
        if (
          origin === optionValue?.b2b?.value ||
          origin?.toLowerCase() === opd
        ) {
          if (order?.id) {
            invoiceResponse = await UpdateLabInvoice(
              order?.origin,
              updatedTestIds,
              order?.odoo_invoice_id,
              order?.ref_id
            )
            const result =
              invoiceResponse?.data?.data?.result ||
              invoiceResponse?.data?.result ||
              invoiceResponse?.data ||
              invoiceResponse?.data?.data
            if (result?.status !== success) {
              setIsSaving(false)
              toast.error(result?.message || failedMsg)
              return false
            }
          } else {
            invoiceResponse = await CreateLabInvoice(
              locationResourceId,
              origin,
              products,
              patientUhid,
              reqOdooId || null,
              reqDoctorRef,
              rows?.[0]?.mode?.value || '',
              false
            )
          }
        }
      }

      const response = invoiceResponse?.data
      if (
        response?.odooApistatus === OPD_ORDERS_CONSTANTS?.ODOO_API_STATUS_ERROR
      ) {
        toast(
          <ToastMessage message={response?.message || orderMsg?.failedmsg} />,
          { ...toastOptions, type: error }
        )
        setIsSaving(false)
        return false
      }

      const odooInvoiceID =
        invoiceResponse?.data?.odoo_invoice_id ??
        invoiceResponse?.data?.document_id ??
        order?.odoo_invoice_id ??
        ''
      const RefID = invoiceResponse?.data?.ref_id ?? order?.ref_id ?? ''
      // Save radiology tests if any
      if (radiologyTestRows.length > 0) {
        const radiologyCombinedResult = radiologyTestRows.map((row) => ({
          testId: Number(row?.testName?.value),
          sampleId: row?.sampleName?.value,
          testName: row?.testName?.label,
          sampleName: row?.sampleName?.label,
          isTestSelect: true,
          packageId: null,
          price: row?.price || null,
          discount: row?.discount || null,
        }))
        await saveRadiologyOrderFromLab(
          mode,
          activeIndex === -1 ? {} : radiologyOrder,
          id,
          patientId || id,
          patientUhid,
          lrNumber,
          radiologyCombinedResult,
          [],
          locationName,
          0,
          radiologyTestRows.reduce((sum, row) => sum + (row?.price || 0), 0),
          requestedBy,
          origin,
          [],
          radiologyCombinedResult,
          odooInvoiceID,
          RefID,
          locationResourceId
        )
      }

      // Save lab tests if any
      if (labRows?.length > 0) {
        const saveOrderResponse = await saveOrder(
          mode,
          order,
          id,
          patientId || id,
          filteredPanels,
          filteredLabTests,
          locationName,
          packageId || OPD_ORDERS_CONSTANTS.PACKAGE_ID_ZERO,
          OPD_ORDERS_CONSTANTS.PACKAGE_ID_ZERO,
          requestedBy,
          origin,
          odooInvoiceID,
          RefID,
          locationId
        )
        setOrder(
          order?.id ? order : saveOrderResponse?.data?.insert_lab_orders_one
        )
        const orderLab: LabOrder = order?.id
          ? saveOrderResponse?.data?.update_lab_orders?.returning?.[0]
          : saveOrderResponse?.data?.insert_lab_orders_one
        let stateObj: Partial<OrderEvent> = {}
        if (orders?.length == 0 || (orders?.length > 0 && activeIndex == -1)) {
          stateObj = {
            updated_by: KeycloakService?.getUsername(),
            order_id: orderLab?.id,
            type: ORDERED,
            tests: prepareOrderEventTests(
              filteredPanels,
              filteredLabTests,
              ORDERED
            ),
          }
          await startSxpProxy(LABS_PROJECT_ID, lmsIntent?.createOrderEvent, {
            event: stateObj,
          })
        } else {
          let body: any = {}
          if (orderLab?.id) {
            body = {
              orderId: orderLab?.id,
              orders,
              filteredPanels,
            }
          }
          const response = await updatedOrderEventByOrderId(body)
          if (!response?.success) {
            toast.error(
              <ToastMessage
                message={response?.message || 'Failed to update order event'}
              />
            )
          }
        }
        setOrder(order ?? {})
      }

      // Success notification and navigation
      toast(<ToastMessage message={order?.id ? orderSucess : orderSubmit} />, {
        ...toastOptions,
        type: success,
      })
      !isPatientView &&
        setTimeout(() => {
          dispatch(
            setLmsDateFilter(
              new Date()
                .toISOString()
                .slice(0, OPD_ORDERS_CONSTANTS.DATE_FORMAT_SLICE)
            )
          )
          dispatch(setLmsActiveTab('collection'))
          if (locations?.pathname?.startsWith(labordercreate)) {
            if (
              order?.origin?.toLowerCase() === opd ||
              origin?.toLowerCase() === opd ||
              origin === optionValue?.b2b?.value
            ) {
              navigate(orderinvoice)
            } else {
              navigate(labDashboard)
            }
          }
        }, OPD_ORDERS_CONSTANTS.TOAST_TIMEOUT)

      getAllLabOrders()
      setNewRowAdded(false)
    } catch (err: any) {
      toast(<ToastMessage message={err?.message || errorinvoice} />, {
        ...toastOptions,
        type: error,
      })
      return false
    } finally {
      setIsSaving(false)
    }
  }
  const handleSave = async () => {
    // Permission check
    if (!KeycloakService?.hasRole([LAB_ORDERS_WRITE])) return
    if (isRadiologyOperation()) {
      await handleRadiologyOrderSave()
    } else {
      await handleLabOrderSave()
    }
  }

  const handleSaveRow = () => {
    if (!newRow?.testName) {
      alert(orderMsg?.TestName)
      return
    }

    // Validation for labordercreate route
    if (locations?.pathname?.startsWith(labordercreate)) {
      if (!newRow?.origin) {
        toast(<ToastMessage message='Please select Origin' />, {
          ...toastOptions,
          type: error,
        })
        return
      }
      if (!newRow?.requestedBy) {
        toast(<ToastMessage message='Please select Requested By' />, {
          ...toastOptions,
          type: error,
        })
        return
      }
      if (
        newRow?.requestedBy?.value === optionValue?.external?.value &&
        !externalText?.trim()
      ) {
        toast(<ToastMessage message='Please enter external name' />, {
          ...toastOptions,
          type: error,
        })
        return
      }
    }

    // Check if it's a radiology test being added in lab order
    if (newRow?.mode?.value === OPD_ORDERS_CONSTANTS.MODE_RADIOLOGY) {
      // If current order is radiology, add to radiologyRows
      if (orderType === radiologyText) {
        const reqBy =
          radiologyRows?.length > 0
            ? radiologyRows?.[0]?.requestedBy
            : newRow?.requestedBy
        const org =
          radiologyRows?.length > 0
            ? radiologyRows?.[0]?.origin
            : newRow?.origin

        const radiologyRowToAdd: OpdRadiologyRow = {
          mode: newRow.mode,
          requestedBy: reqBy,
          origin: org,
          sampleName: newRow.sampleName,
          testName: newRow.testName,
          packageName: null,
          packageTests: null,
          price: newRow.price || 0,
          discount: newRow.discount || 0,
          panel: newRow.panel,
        }

        setRadiologyRows([...radiologyRows, radiologyRowToAdd])

        const nextRow = {
          mode: newRow.mode,
          requestedBy: reqBy,
          origin: org,
          sampleName: null,
          testName: null,
          panel: null,
          price: 0,
          discount: 0,
        }
        setNewRow(nextRow)
        setNewRowAdded(true)
        setRadiologyTestAdded((prev) => !prev)
        return
      }

      // Otherwise, add to lab rows so it renders in lab UI and disables options
      const reqBy =
        rows?.length > 0 ? rows?.[0]?.requestedBy : newRow?.requestedBy
      const org = rows?.length > 0 ? rows?.[0]?.origin : newRow?.origin
      const updatedRows = [
        ...rows,
        {
          ...newRow,
          requestedBy: reqBy,
          origin: org,
        },
      ]
      setRows(updatedRows)

      const nextRow = {
        mode: newRow.mode,
        requestedBy: reqBy,
        origin: org,
        sampleName: null,
        testName: null,
        panel: null,
        price: 0,
        discount: 0,
      }
      setNewRow(nextRow)
      setNewRowAdded(true)
      if (newRow.testName) {
        setSelectedTests([...selectedTests, newRow?.testName])
      }
      setTestAdded((prev) => !prev)
      return
    }

    // Handle regular lab tests
    const reqBy =
      rows?.length > 0 ? rows?.[0]?.requestedBy : newRow?.requestedBy
    const org = rows?.length > 0 ? rows?.[0]?.origin : newRow?.origin
    const updatedRows = [
      ...rows,
      {
        ...newRow,
        requestedBy: reqBy,
        origin: org,
      },
    ]
    setRows(updatedRows)
    const nextRow = {
      mode: newRow.mode,
      requestedBy: reqBy,
      origin: org,
      sampleName: null,
      testName: null,
      panel: null,
      price: 0,
      discount: 0,
    }
    setNewRow(nextRow)
    setNewRowAdded(true)
    if (newRow.testName) {
      setSelectedTests([...selectedTests, newRow?.testName])
    }
    setTestAdded((prev) => !prev)
  }

  const handleRequestedByChange = (selectedOption: any) => {
    setNewRow((prev) => ({ ...prev, requestedBy: selectedOption }))
  }

  const handleOriginChange = (selectedOption: any) => {
    const selectedValue = selectedOption?.value || ''
    setOrigin(selectedValue)
    setNewRow((prev) => ({ ...prev, origin: selectedOption }))
  }
  const organizations = useLabOrganizations()
  const doctors = useAppSelector(selectSlotsDoctors)
  const handleDeleteRow = (index: number) => {
    setRows((prevRows: Row[]) => {
      const updatedRows = [...prevRows]
      updatedRows.splice(index, 1)
      return updatedRows
    })
    setNewRowAdded(true)
  }

  const handleDeleteRadiologyRow = (index: number) => {
    setRadiologyRows((prevRows: OpdRadiologyRow[]) => {
      const updatedRows = [...prevRows]
      updatedRows?.splice(index, 1)
      return updatedRows
    })
    setNewRowAdded(true)
  }

  const handleRadiologyTestNameChange = async (selectedOption: any) => {
    if (!selectedOption) return

    const updatedRow: any = {
      testName: {
        label: selectedOption?.label,
        value: selectedOption?.value,
        odoo_test_id: selectedOption?.odoo_test_id,
      },
      sampleName: {
        label: selectedOption?.sampleName,
        value: selectedOption?.sampleId,
      },
    }

    const priceList = location?.resource?.type?.[0]?.coding?.find(
      (item: any) => item.code === PriceList
    )?.display

    setPriceLoading(true)
    const b2bOrigin = origin === 'B2B'
    const reqDoctorRef = radiologyNewRow?.requestedBy?.doctorRef

    const result = await fetchRadiologyTestPrice({
      locationResourceId: location?.resource?.id,
      patientId: id,
      odooTestId: selectedOption?.odoo_test_id,
      priceList,
      b2bOrigin,
      reqPatnerId: radiologyNewRow?.requestedBy?.odooId,
      reqDoctorRef,
    })

    setPriceLoading(false)

    if (result.success && result.data) {
      const { price, defaultPrice, pricelistId, discount } = result.data
      updatedRow.price = price
      updatedRow.discount = discount
      updatedRow.defaultPrice = defaultPrice
      updatedRow.panel = {
        ...updatedRow.testName,
        price,
        discount,
        defaultPrice,
        pricelist_id: pricelistId,
        best_price: price,
      }
      setRadiologyNewRow((prev) => ({ ...prev, ...updatedRow }))
    } else {
      const errorMsg = result.error || priceFailedMsg
      toast(<ToastMessage message={errorMsg} />, {
        ...toastOptions,
        type: error,
      })
    }
  }

  const handleSaveRadiologyRow = () => {
    if (
      radiologyNewRow?.mode?.value === radiologyText &&
      !radiologyNewRow?.testName
    ) {
      toast?.warn('Please select a radiology test')
      return
    }

    // Validation for labordercreate route
    if (locations?.pathname?.startsWith(labordercreate)) {
      if (!radiologyNewRow?.origin) {
        toast(<ToastMessage message='Please select Origin' />, {
          ...toastOptions,
          type: error,
        })
        return
      }
      if (!radiologyNewRow?.requestedBy) {
        toast(<ToastMessage message='Please select Requested By' />, {
          ...toastOptions,
          type: error,
        })
        return
      }
    }

    const reqBy =
      radiologyRows?.length > 0
        ? radiologyRows?.[0]?.requestedBy
        : radiologyNewRow?.requestedBy
    const org =
      radiologyRows?.length > 0
        ? radiologyRows?.[0]?.origin
        : radiologyNewRow?.origin

    const updatedRows = [
      ...radiologyRows,
      {
        ...radiologyNewRow,
        requestedBy: reqBy,
        origin: org,
      },
    ]
    setRadiologyRows(updatedRows)

    const nextRow: OpdRadiologyRow = {
      mode: radiologyNewRow.mode,
      requestedBy: reqBy,
      origin: org,
      sampleName: null,
      testName: null,
      packageName: null,
      packageTests: null,
      price: 0,
      discount: 0,
    }
    setRadiologyNewRow(nextRow)
    setNewRowAdded(true)
    setRadiologyTestAdded((prev) => !prev)
  }

  useEffect(() => {
    dispatch(fetchSlotsDoctorsAsync())
  }, [dispatch])

  const fetchRadiologyData = async () => {
    try {
      const radiologyOrderData = await getRadiologyOrdersForPatientForOpd(
        id,
        location?.resource?.name ?? ''
      )
      const radOrders: RadiologyOrders[] = radiologyOrderData?.data ?? []
      setRadiologyOrders(radOrders)
      // Only set active order if activeIndex is not -1 (new order)
      // The useEffect will handle calling handleActiveRadiologyOrderChange based on activeIndex
    } catch (err) {
      console.error(err)
    }
  }

  const fetchRadiologyTestOptions = () => {
    const state = {}
    startSxpProxy(
      RADIOLOGY_PROJECT_ID,
      radiologyIntents?.getRadiologyTestsAPI,
      state
    )
      .then((data) => {
        const panelData = data?.data?.radiology_lab_test ?? []
        const tests = panelData?.map((test: any) => ({
          label: test?.name,
          value: test?.id,
          sampleId: test?.sample_id,
          sampleName: test?.radiology_sample?.name,
          odoo_test_id: test?.odoo_test_id,
        }))
        const selectedTestLabels = radiologyRows?.map(
          (row) => row?.testName?.label
        )
        const filteredTests = tests?.filter(
          (test: any) => !selectedTestLabels.includes(test?.label)
        )
        setRadiologyTestNameOptions(filteredTests)
      })
      .catch((error) => {
        console.error('Error fetching radiology test names:', error)
        setRadiologyTestNameOptions([])
      })
  }

  const fetchData = async () => {
    try {
      const labOrderData = await startSxpProxy(
        LABS_PROJECT_ID,
        lmsIntent?.getLabOrdersByPatientIdForOpd,
        { patientId: id, source: location?.resource?.name }
      )
      const orders: LabOrder[] = labOrderData?.data?.lab_orders ?? []
      setOrders(orders)
      handleActiveOrderChage(orders)
      await fetchRadiologyData()
    } catch (err) {
      console.error(err)
    }
  }

  const getAllLabOrders = async () => {
    const labResult = await getLabOrdersByVisitId(id)
    const orders: LabOrder[] = labResult.data
    setOrders(orders)
    handleActiveOrderChage(orders)

    const [visitResult, radResult] = await Promise.all([
      getVisitByEncounterId(id),
      getRadiologyOrdersByVisitId(id),
    ])
    if (visitResult.success && visitResult.data) {
      setPatientId(
        visitResult.data?.subject?.reference?.split(
          OPD_ORDERS_CONSTANTS.IDENTIFIER_SPLIT
        )?.[1]
      )
      SetVisitStatus(visitResult.data?.statusHistory?.[0]?.status)
    }

    const radOrders: RadiologyOrders[] = radResult.data
    setRadiologyOrders(radOrders)
  }

  useEffect(() => {
    if (window.location.pathname === `${labordercreate}/${id}`) {
      fetchData()
    } else {
      getAllLabOrders()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])
  const handleActiveOrderChage = (orders: LabOrder[]) => {
    let activeOrder: any = {}
    {
      activeOrder = orders[activeIndex] ?? {}
    }
    setOrder(activeOrder)
    const formattedRows: any = activeOrder?.panels?.map((panel: any) => {
      return {
        mode: {
          label: activeOrder?.package_id ? 'Lab Package' : 'Lab Test',
          value: activeOrder?.package_id ? 'package' : 'test',
        },
        requestedBy: {
          label: activeOrder?.requested_by,
          value: activeOrder?.requested_by,
        },
        origin: {
          label: activeOrder?.origin,
          value: activeOrder?.origin,
        },
        sampleName:
          panel?.sampleName && panel?.sampleId
            ? { label: panel?.sampleName, value: panel?.sampleId }
            : null,

        testName:
          panel?.name && panel?.id
            ? { label: panel?.name, value: panel?.id }
            : null,
        panel: panel || null,
      }
    })
    setRows(formattedRows || [])
    setOrdersEvent(activeOrder?.order_events ?? [])
    setOrder(activeOrder)
    if (
      activeOrder?.id &&
      activeOrder?.panels &&
      activeOrder?.panels?.length >= 1
    ) {
      setNewRow({
        mode: {
          label: activeOrder?.package_id
            ? labModule?.labPackage
            : labModule?.labTest,
          value: activeOrder?.package_id ? 'package' : 'test',
        },
        requestedBy: {
          label: activeOrder?.requested_by,
          value: activeOrder?.requested_by,
        },
        sampleName: null,
        testName: null,
        panel: null,
        origin: {
          label: activeOrder?.origin,
          value: activeOrder?.origin,
        },
      })
    } else {
      setNewRow({
        mode: null,
        requestedBy: null,
        sampleName: null,
        testName: null,
        panel: null,
        origin: null,
      })
    }
  }

  const handleActiveRadiologyOrderChange = (orders: RadiologyOrders[]) => {
    let activeOrder: any = {}
    if (activeIndex === -1) {
      activeOrder = {}
    } else {
      activeOrder = orders[activeIndex] ?? {}
    }

    setRadiologyOrder(activeOrder)
    const formattedRows: OpdRadiologyRow[] = activeOrder?.id
      ? transformData(activeOrder, labConstant)
      : []
    setRadiologyRows(formattedRows || [])

    const firstRow = formattedRows?.[0]
    setRadiologyNewRow((prev) => ({
      ...prev,
      origin: firstRow?.origin ?? prev.origin,
      requestedBy: firstRow?.requestedBy ?? prev.requestedBy,
    }))
    setOrigin(firstRow?.origin?.value ?? origin)
  }

  useEffect(() => {
    const resizeHandler = () => {
      const container = VisitTableRef.current
      if (container) {
        const availableHeight =
          window.innerHeight - container.getBoundingClientRect().top
        container.style.maxHeight = `${Math.max(200, availableHeight - 150)}px`
      }
    }
    window.addEventListener(
      OPD_ORDERS_CONSTANTS.WINDOW_RESIZE_EVENT,
      resizeHandler
    )
    resizeHandler()
    return () => {
      window.removeEventListener(
        OPD_ORDERS_CONSTANTS.WINDOW_RESIZE_EVENT,
        resizeHandler
      )
      dispatch(setQueryParam({ q: '', param: '' }))
    }
  }, [dispatch])

  useEffect(() => {
    if (
      orderType === labConstant &&
      newRow?.mode?.value === OPD_ORDERS_CONSTANTS.MODE_TEST
    ) {
      executeFunction()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testAdded, rows, orderType, newRow?.mode?.value])

  useEffect(() => {
    if (orderType === labConstant) {
      handleActiveOrderChage(orders)
    } else if (orderType === radiologyText) {
      if (activeIndex === -1) {
        // New radiology order
        setRadiologyOrder({})
        setRadiologyRows([])
      } else {
        handleActiveRadiologyOrderChange(radiologyOrders)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeIndex])

  const locations = useLocation()
  const baseOptions = [
    optionValue?.origin,
    optionValue?.ipd,
    optionValue?.partner,
    optionValue?.others,
  ]
  const shouldFetchRadiologyTestsForLabOrder = useMemo(() => {
    return newRow?.mode?.value === radiologyText && orderType === labConstant
  }, [newRow?.mode?.value, orderType])

  useEffect(() => {
    if (shouldFetchRadiologyTestsForLabOrder) {
      fetchRadiologyTests()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldFetchRadiologyTestsForLabOrder, testAdded, rows])

  useEffect(() => {
    if (orderType === radiologyText) {
      fetchRadiologyTestOptions()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [radiologyTestAdded, radiologyRows, orderType])
  useEffect(() => {
    if (locations.pathname.startsWith(labordercreate)) {
      setNewRow((prevState) => ({
        ...prevState,
        origin: optionValue?.origin,
      }))
    }
  }, [locations.pathname, setNewRow])
  const handleIndexChange = (index: any, type?: 'lab' | 'radiology') => {
    setActiveIndex(index)
    setNewRowAdded(false)

    if (type) {
      setOrderType(type)
      if (type === radiologyText) {
        // Reset radiology order to empty when creating new order
        if (index === -1) {
          setRadiologyOrder({})
          setRadiologyRows([])
        } else {
          handleActiveRadiologyOrderChange(radiologyOrders)
        }
      } else {
        handleActiveOrderChage(orders)
      }
    }
  }
  const isPointerEventsDisabled = ordersEvent?.some((event) =>
    event.tests?.some(
      (test) =>
        test.status !== OPD_ORDERS_CONSTANTS.STATUS_ORDER_MODIFIED &&
        test.status !== OPD_ORDERS_CONSTANTS.STATUS_ORDERED
    )
  )
  const getRequestedByOptions = () => {
    const selfOption = optionValue?.self
    const externalOption = optionValue?.external

    const dynamicOptions =
      newRow?.origin?.value === optionValue?.b2b?.value
        ? organizations?.map((org: any) => ({
            value: org?.name,
            label: org?.name,
            odooId: org?.odoo_partner_id,
          }))
        : doctors?.map((d: Doctor) => {
            const qualificationPart = d?.qualification
              ? `${
                  OPD_ORDERS_CONSTANTS.QUALIFICATION_PREFIX
                }${d?.qualification?.toUpperCase()}${
                  OPD_ORDERS_CONSTANTS.QUALIFICATION_SUFFIX
                }`
              : ''
            const specialtyPart = d?.specialty
              ? `${OPD_ORDERS_CONSTANTS.SPECIALTY_PREFIX}${d?.specialty}${OPD_ORDERS_CONSTANTS.SPECIALTY_SUFFIX}`
              : ''
            const displayName =
              `${OPD_ORDERS_CONSTANTS.DOCTOR_PREFIX}${d?.name}${qualificationPart}${specialtyPart}`.trim()
            const doctorRef = d?.id
            return {
              value: displayName,
              label: displayName,
              doctorRef: doctorRef,
            }
          }) || []

    return [selfOption, ...dynamicOptions, externalOption]
  }
  const b2bOrderCode = location?.resource?.type?.[0]?.coding?.find(
    (c) => c?.code === B2BOrderValue
  )
  const shouldShowB2BOrigin =
    !b2bOrderCode || b2bOrderCode?.display === DECISION_OPTIONS?.[0]?.value
  const getOriginOptions = () => {
    if (newRow?.mode?.value === OPD_ORDERS_CONSTANTS.MODE_RADIOLOGY) {
      return [optionValue?.origin, optionValue?.ipd, optionValue?.others]
    }
    return shouldShowB2BOrigin
      ? [...baseOptions, optionValue?.b2b]
      : baseOptions
  }

  // Computed options for test name select with disabled state
  const testNameOptionsWithDisabled = useMemo(() => {
    return testNameOptions?.map((option) => ({
      ...option,
      isDisabled: rows?.some((row) => row?.testName?.value === option?.value),
      odoo_test_id: option?.odoo_testId,
    }))
  }, [testNameOptions, rows])

  // Computed options for radiology test select with disabled state
  const radiologyTestOptionsWithDisabled = useMemo(() => {
    return radiologyTestOptions?.map((option) => ({
      ...option,
      isDisabled: rows?.some((row) => row?.testName?.value === option?.value),
    }))
  }, [radiologyTestOptions, rows])

  const renderTestOrPackage = () => {
    if (newRow?.mode?.value === OPD_ORDERS_CONSTANTS.MODE_PACKAGE) {
      return (
        <PackageTests
          key={newRow.mode?.value}
          id={order?.package_id ?? OPD_ORDERS_CONSTANTS.PACKAGE_ID_ZERO}
          status={order?.status ?? ''}
          onTestSelect={handlePackageTestSelect}
          onChange={handleTestNameChange}
        />
      )
    }

    if (newRow?.mode?.value === OPD_ORDERS_CONSTANTS.MODE_TEST) {
      return (
        <Select
          options={testNameOptionsWithDisabled}
          value={newRow?.testName}
          onChange={handleTestNameChange}
          classNamePrefix={OPD_ORDERS_CONSTANTS.CLASSNAME_REACT_SELECT}
          className='lms-custom-select'
          menuPortalTarget={document.body}
          menuPosition='fixed'
          classNames={{
            menuPortal: () => 'lms-custom-select-portal',
            menu: () => 'lms-custom-select-menu',
            menuList: () => 'lms-custom-select-menu-list',
            option: () => 'lms-custom-select-option',
            singleValue: () => 'lms-custom-select-single-value',
          }}
        />
      )
    }

    if (newRow?.mode?.value === OPD_ORDERS_CONSTANTS.MODE_RADIOLOGY) {
      return (
        <Select
          options={radiologyTestOptionsWithDisabled}
          value={newRow?.testName}
          onChange={handleRadiologyTestChange}
          placeholder={OPD_ORDERS_CONSTANTS.PLACEHOLDER_RADIOLOGY_TEST}
          classNamePrefix={OPD_ORDERS_CONSTANTS.CLASSNAME_REACT_SELECT}
          className='lms-custom-select'
          menuPortalTarget={document.body}
          menuPosition='fixed'
          classNames={{
            menuPortal: () => 'lms-custom-select-portal',
            menu: () => 'lms-custom-select-menu',
            menuList: () => 'lms-custom-select-menu-list',
            option: () => 'lms-custom-select-option',
            singleValue: () => 'lms-custom-select-single-value',
          }}
        />
      )
    }

    return null
  }

  const handlePackageTestSelect = ({
    packageId,
    productName,
    packagePrice,
    OdooPackageId,
    panels,
  }: {
    packageId: number
    productName: string
    packagePrice: number
    OdooPackageId: any
    panels: Panel[]
  }) => {
    setNewRow((prev: any) => {
      const updatedPanels = [...(prev.panels ?? []), ...panels]

      return {
        ...prev,
        packageId,
        packagePrice,
        panels: updatedPanels,
        allPanelNames: updatedPanels?.map((p) => p.name)?.join(', '),
        testName: updatedPanels?.[0]
          ? { label: updatedPanels?.[0].name, value: updatedPanels?.[0].id }
          : prev?.testName,
        panel: updatedPanels?.[0] ?? prev.panel,
        productName,
        OdooPackageId,
      }
    })
  }
  const isSaveDisabled = () => {
    if (orderType === radiologyText) {
      return isSaving || !newrowadded || radiologyRows?.length === 0
    }
    return (
      isSaving ||
      !newrowadded ||
      visitStatus === OPD_ORDERS_CONSTANTS.FINISHED_STATUS ||
      (activeIndex > 0 &&
        Number(orders?.[activeIndex]?.package_id) !==
          OPD_ORDERS_CONSTANTS.PACKAGE_ID_ZERO) ||
      ordersEvent?.some((event) =>
        event?.tests?.some(
          (test) =>
            test?.status !== OPD_ORDERS_CONSTANTS.STATUS_ORDER_MODIFIED &&
            test?.status !== OPD_ORDERS_CONSTANTS.STATUS_ORDERED
        )
      ) ||
      rows?.length === 0
    )
  }
  const existingOrderCondition = orders?.map((ord, idx) => ({
    value: idx,
    label: `Lab Order ${ord?.id}${OPD_ORDERS_CONSTANTS.TITLE_SEPARATOR}${
      ord?.source ?? ''
    }${OPD_ORDERS_CONSTANTS.TITLE_SEPARATOR}${ord?.origin ?? ''}`,
    title: `${OPD_ORDERS_CONSTANTS.TITLE_PREFIX_ORDER}${ord?.id}${
      OPD_ORDERS_CONSTANTS.TITLE_SEPARATOR
    } ${readableDateTimeFormat(new Date(ord?.ordered_on ?? ''))}`,
    type: 'lab' as const,
  }))

  const existingRadiologyOrderCondition = radiologyOrders?.map((ord, idx) => ({
    value: idx,
    label: `Radiology Order ${ord?.id}${OPD_ORDERS_CONSTANTS.TITLE_SEPARATOR}${
      ord?.source ?? ''
    }${OPD_ORDERS_CONSTANTS.TITLE_SEPARATOR}${ord?.origin ?? ''}`,
    title: `Radiology Order ${ord?.id}${
      OPD_ORDERS_CONSTANTS.TITLE_SEPARATOR
    } ${readableDateTimeFormat(new Date(ord?.ordered_on ?? ''))}`,
    type: 'radiology' as const,
  }))

  // Selected radiology order option for the dropdown
  const selectedRadiologyOrderOption = useMemo(() => {
    if (activeIndex === -1 || orderType !== radiologyText) return null
    return {
      value: activeIndex,
      label: `Radiology Order ${radiologyOrders?.[activeIndex]?.id}${
        OPD_ORDERS_CONSTANTS?.TITLE_SEPARATOR
      }${radiologyOrders[activeIndex]?.source ?? ''}${
        OPD_ORDERS_CONSTANTS?.TITLE_SEPARATOR
      }${radiologyOrders[activeIndex]?.origin ?? ''}`,
    }
  }, [activeIndex, orderType, radiologyOrders])

  // Handle radiology order selection change
  const handleRadiologyOrderChange = (option: any) => {
    if (option) {
      handleIndexChange(option.value, 'radiology')
    } else {
      handleIndexChange(-1, 'radiology')
    }
  }

  // Selected lab order option for the dropdown
  const selectedLabOrderOption = useMemo(() => {
    if (
      activeIndex === -1 ||
      orderType !== labConstant ||
      !orders?.[activeIndex]
    )
      return null
    return {
      value: activeIndex,
      label: `Lab Order ${orders[activeIndex].id}${
        OPD_ORDERS_CONSTANTS.TITLE_SEPARATOR
      }${orders[activeIndex].source ?? ''}${
        OPD_ORDERS_CONSTANTS.TITLE_SEPARATOR
      }${orders[activeIndex].origin ?? ''}`,
    }
  }, [activeIndex, orderType, orders])

  // Handle lab order selection change
  const handleLabOrderChange = (option: any) => {
    if (option) {
      handleIndexChange(option.value, labConstant)
    } else {
      handleIndexChange(-1, labConstant)
    }
  }

  const isEditingLabOrder = orderType === labConstant && activeIndex !== -1
  const isEditingRadiologyOrder =
    orderType === radiologyText && activeIndex !== -1
  const radiologyModeLabel = OPD_ORDERS_CONSTANTS.LABEL_RADIOLOGY || radiology
  const renderParameters = (parameters: any) => {
    return (
      <div>
        {parameters?.map((item: LabTests) => {
          return <li key={item?.id}>{item?.name}</li>
        })}
      </div>
    )
  }

  return (
    <div className='orders-container'>
      {/* needed */}
      {/* {!window.location.pathname.startsWith(labordercreate) && ( */}
      <div className='order-buttons-wrapper'>
        <div className='order-buttons-wrap'>
          <div className='order-buttons-wrap'>
            <div className='order-select-container'>
              <Select
                classNamePrefix={OPD_ORDERS_CONSTANTS.CLASSNAME_REACT_SELECT}
                className='order-select'
                value={selectedLabOrderOption}
                onChange={handleLabOrderChange}
                options={existingOrderCondition}
                placeholder='Select Lab Order'
                isClearable
                menuPortalTarget={document.body}
                menuPosition='fixed'
                classNames={{
                  menuPortal: () => 'lms-custom-select-portal',
                  menu: () => 'lms-custom-select-menu',
                  menuList: () => 'lms-custom-select-menu-list',
                  option: () => 'lms-custom-select-option',
                  singleValue: () => 'lms-custom-select-single-value',
                }}
              />
            </div>
            <div className='order-select-container'>
              <Select
                classNamePrefix={OPD_ORDERS_CONSTANTS?.CLASSNAME_REACT_SELECT}
                className='order-select'
                value={selectedRadiologyOrderOption}
                onChange={handleRadiologyOrderChange}
                options={existingRadiologyOrderCondition}
                placeholder='Select Radiology Order'
                isClearable
                menuPortalTarget={document.body}
                menuPosition='fixed'
                classNames={{
                  menuPortal: () => 'lms-custom-select-portal',
                  menu: () => 'lms-custom-select-menu',
                  menuList: () => 'lms-custom-select-menu-list',
                  option: () => 'lms-custom-select-option',
                  singleValue: () => 'lms-custom-select-single-value',
                }}
              />
            </div>
            <button
              className={`order-btn new-order-btn${
                activeIndex === -1 ? ' active-order-btn active-new-order' : ''
              }`}
              onClick={() => {
                setOrderType(labConstant)
                handleIndexChange(-1, labConstant)
                setRadiologyOrder({})
                setOrder({})
              }}
            >
              {NewOrder}
            </button>
          </div>
          <div>
            <Button
              onClick={handleSave}
              disabled={isSaveDisabled()}
              size='medium'
              variant='contained'
              className='submit-button'
            >
              {isSaving
                ? OPD_ORDERS_CONSTANTS.BUTTON_TEXT_SAVING
                : OPD_ORDERS_CONSTANTS.BUTTON_TEXT_SUBMIT_ORDER}
            </Button>
          </div>
        </div>
      </div>
      {/* )} */}
      <div className='createlaborder-table'>
        <div
          ref={VisitTableRef}
          className={`${classes.tableScrollContainer} ${
            isPointerEventsDisabled
              ? ''
              : OPD_ORDERS_CONSTANTS.CLASSNAME_POINTER_EVENTS_AUTO
          }`}
        >
          <div className={`table-wrapper ${classes.tableWrapper}`}>
            <TableContainer className={classes.tableContainer}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.colSlNo}>Sl.No</TableCell>
                    <TableCell className={classes.colDate}>Date</TableCell>

                    <TableCell className={classes.colMode}>
                      {LmstableHeading?.Mode}
                    </TableCell>
                    {locations.pathname.startsWith(labordercreate) && (
                      <TableCell className={classes.colOrigin}>
                        {LmstableHeading?.Origin}
                      </TableCell>
                    )}
                    {locations.pathname.startsWith(labordercreate) && (
                      <TableCell className={classes.colRequestedBy}>
                        {LmstableHeading?.RequestedBy}
                      </TableCell>
                    )}
                    <TableCell className={classes.colTestName}>
                      {newRow?.mode?.value === OPD_ORDERS_CONSTANTS.MODE_PACKAGE
                        ? selectTests
                        : LmstableHeading?.TestName}
                    </TableCell>
                    {newRow?.mode?.value ===
                      OPD_ORDERS_CONSTANTS.MODE_PACKAGE &&
                      orderType === labConstant && (
                        <TableCell className={classes.colParamTests}>
                          parameter Tests
                        </TableCell>
                      )}
                    <TableCell className={classes.colQuantity}>
                      Quantity
                    </TableCell>
                    <TableCell className={classes.colPrice}>
                      {LmstableHeading?.Price}
                    </TableCell>
                    <TableCell className={classes.colDiscount}>
                      Discount
                    </TableCell>
                    <TableCell className={classes.colSubtotal}>
                      Subtotal
                    </TableCell>
                    <TableCell className={classes.colAction}>
                      {LmstableHeading?.Action}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {orderType === labConstant && (
                    <TableRow className='new-row'>
                      <TableCell>-</TableCell>
                      <TableCell>{new Date().toLocaleDateString()}</TableCell>
                      <TableCell>
                        <Select
                          value={newRow?.mode || ''}
                          onChange={(selected) => handleModeChange(selected)}
                          options={[
                            optionValue?.test,
                            optionValue?.package,
                            {
                              label: OPD_ORDERS_CONSTANTS.LABEL_RADIOLOGY,
                              value: OPD_ORDERS_CONSTANTS.MODE_RADIOLOGY,
                            },
                          ]}
                          isDisabled={isRowAdded || isEditingLabOrder}
                          classNamePrefix={
                            OPD_ORDERS_CONSTANTS.CLASSNAME_REACT_SELECT
                          }
                          menuPortalTarget={document.body}
                        />
                      </TableCell>
                      {locations?.pathname?.startsWith(labordercreate) && (
                        <TableCell className='col-origin'>
                          <Select
                            isClearable
                            value={newRow?.origin}
                            onChange={handleOriginChange}
                            options={getOriginOptions()}
                            className='lms-custom-select'
                            menuPortalTarget={document.body}
                            menuPosition='fixed'
                            isDisabled={rows?.length > 0}
                            classNames={{
                              menuPortal: () => 'lms-custom-select-portal',
                              menu: () => 'lms-custom-select-menu',
                              menuList: () => 'lms-custom-select-menu-list',
                              option: () => 'lms-custom-select-option',
                              singleValue: () =>
                                'lms-custom-select-single-value',
                            }}
                          />
                        </TableCell>
                      )}
                      {locations?.pathname?.startsWith(labordercreate) && (
                        <TableCell className='col-requested-by'>
                          <Select
                            placeholder='Select Requested By'
                            className='origin-select react-select'
                            classNamePrefix={
                              OPD_ORDERS_CONSTANTS.CLASSNAME_REACT_SELECT
                            }
                            isClearable
                            value={newRow?.requestedBy || ''}
                            onChange={(selected) => {
                              handleRequestedByChange(selected)
                            }}
                            options={getRequestedByOptions()}
                            menuPortalTarget={document.body}
                            menuPosition='fixed'
                            isDisabled={rows?.length > 0}
                          />
                          {newRow?.requestedBy?.value ===
                            optionValue?.external?.value && (
                            <input
                              type='text'
                              placeholder={externalName}
                              value={externalText}
                              className='external-name-input'
                              onChange={(e) => setExternalText(e.target.value)}
                              disabled={rows?.length > 0}
                            />
                          )}
                        </TableCell>
                      )}
                      <TableCell className='col-test-name'>
                        {renderTestOrPackage()}
                      </TableCell>
                      {newRow?.mode?.value ===
                        OPD_ORDERS_CONSTANTS.MODE_PACKAGE && (
                        <TableCell className='col-test-name'>
                          {renderParameters(newRow?.panels || [])}
                        </TableCell>
                      )}

                      <TableCell className='text-center col-quantity'>
                        1
                      </TableCell>
                      <TableCell>
                        {priceLoading ? (
                          <span className='loader'>{LoadPrice}</span>
                        ) : (
                          <span>
                            {OPD_ORDERS_CONSTANTS.CURRENCY_SYMBOL}{' '}
                            {newRow?.defaultPrice?.toFixed(
                              OPD_ORDERS_CONSTANTS.DECIMAL_PLACES
                            ) || OPD_ORDERS_CONSTANTS.DEFAULT_PRICE}
                          </span>
                        )}
                      </TableCell>
                      <TableCell>
                        {newRow?.discount?.toFixed(
                          OPD_ORDERS_CONSTANTS.DECIMAL_PLACES
                        ) || '0.00'}
                        %
                      </TableCell>
                      <TableCell>
                        {OPD_ORDERS_CONSTANTS.CURRENCY_SYMBOL}{' '}
                        {newRow?.price?.toFixed(
                          OPD_ORDERS_CONSTANTS.DECIMAL_PLACES
                        ) || OPD_ORDERS_CONSTANTS.DEFAULT_PRICE}
                      </TableCell>
                      <TableCell>
                        <Button
                          onClick={handleSaveRow}
                          size='small'
                          variant='contained'
                          className='add-button'
                        >
                          {add}
                        </Button>
                      </TableCell>
                    </TableRow>
                  )}
                  {orderType === 'radiology' && (
                    <TableRow className='new-row'>
                      <TableCell>-</TableCell>
                      <TableCell>{new Date().toLocaleDateString()}</TableCell>
                      <TableCell>
                        <Select
                          value={radiologyNewRow?.mode || ''}
                          onChange={(selected) => handleModeChange(selected)}
                          options={[
                            { label: 'Lab Test', value: 'test' },
                            { label: 'Lab Package', value: 'package' },
                            {
                              label: OPD_ORDERS_CONSTANTS.LABEL_RADIOLOGY,
                              value: OPD_ORDERS_CONSTANTS.MODE_RADIOLOGY,
                            },
                          ]}
                          isDisabled={isEditingRadiologyOrder}
                          classNamePrefix={
                            OPD_ORDERS_CONSTANTS?.CLASSNAME_REACT_SELECT
                          }
                          menuPortalTarget={document.body}
                        />
                      </TableCell>
                      {locations.pathname.startsWith(labordercreate) && (
                        <TableCell className='col-origin'>
                          <Select
                            isClearable
                            value={radiologyNewRow?.origin}
                            onChange={(selected) => {
                              const selectedValue = selected?.value || ''
                              setOrigin(selectedValue)
                              setRadiologyNewRow((prev) => ({
                                ...prev,
                                origin: selected,
                              }))
                            }}
                            options={[
                              optionValue?.origin,
                              optionValue?.ipd,
                              optionValue?.others,
                            ]}
                            className='lms-custom-select'
                            menuPortalTarget={document.body}
                            menuPosition='fixed'
                            isDisabled={radiologyRows?.length > 0}
                            classNames={{
                              menuPortal: () => 'lms-custom-select-portal',
                              menu: () => 'lms-custom-select-menu',
                              menuList: () => 'lms-custom-select-menu-list',
                              option: () => 'lms-custom-select-option',
                              singleValue: () =>
                                'lms-custom-select-single-value',
                            }}
                          />
                        </TableCell>
                      )}
                      {locations.pathname.startsWith(labordercreate) && (
                        <TableCell className='col-requested-by'>
                          <Select
                            placeholder='Select Requested By'
                            className='origin-select react-select'
                            classNamePrefix={
                              OPD_ORDERS_CONSTANTS.CLASSNAME_REACT_SELECT
                            }
                            isClearable
                            value={radiologyNewRow?.requestedBy || ''}
                            onChange={(selected) => {
                              setRadiologyNewRow((prev) => ({
                                ...prev,
                                requestedBy: selected,
                              }))
                            }}
                            options={getRequestedByOptions()}
                            menuPortalTarget={document.body}
                            menuPosition='fixed'
                            isDisabled={radiologyRows?.length > 0}
                          />
                        </TableCell>
                      )}
                      <TableCell className='col-test-name'>
                        {radiologyNewRow?.mode?.value === radiologyText &&
                        orderType === 'radiology' ? (
                          <Select
                            options={radiologyTestNameOptions?.map(
                              (option) => ({
                                ...option,
                                isDisabled: radiologyRows?.some(
                                  (row) =>
                                    row?.testName?.value === option?.value
                                ),
                              })
                            )}
                            value={radiologyNewRow?.testName}
                            onChange={handleRadiologyTestNameChange}
                            placeholder='Select Radiology Test'
                            classNamePrefix={
                              OPD_ORDERS_CONSTANTS.CLASSNAME_REACT_SELECT
                            }
                            className='lms-custom-select'
                            menuPortalTarget={document.body}
                            menuPosition='fixed'
                            classNames={{
                              menuPortal: () => 'lms-custom-select-portal',
                              menu: () => 'lms-custom-select-menu',
                              menuList: () => 'lms-custom-select-menu-list',
                              option: () => 'lms-custom-select-option',
                              singleValue: () =>
                                'lms-custom-select-single-value',
                            }}
                          />
                        ) : (
                          'Select Test/Package'
                        )}
                      </TableCell>
                      {!(
                        radiologyNewRow?.mode?.value === radiologyText &&
                        orderType === 'radiology'
                      ) && <TableCell className='col-test'>-</TableCell>}
                      <TableCell>1</TableCell>
                      <TableCell>
                        {priceLoading ? (
                          <span className='loader'>{LoadPrice}</span>
                        ) : (
                          <span>
                            {OPD_ORDERS_CONSTANTS.CURRENCY_SYMBOL}{' '}
                            {radiologyNewRow?.defaultPrice?.toFixed(
                              OPD_ORDERS_CONSTANTS.DECIMAL_PLACES
                            ) || OPD_ORDERS_CONSTANTS.DEFAULT_PRICE}
                          </span>
                        )}
                      </TableCell>
                      <TableCell>
                        {radiologyNewRow?.discount?.toFixed(
                          OPD_ORDERS_CONSTANTS.DECIMAL_PLACES
                        ) || '0.00'}
                        %
                      </TableCell>
                      <TableCell>
                        {OPD_ORDERS_CONSTANTS.CURRENCY_SYMBOL}{' '}
                        {(radiologyNewRow?.price || 0)?.toFixed(
                          OPD_ORDERS_CONSTANTS.DECIMAL_PLACES
                        )}
                      </TableCell>
                      <TableCell>
                        <Button
                          onClick={handleSaveRadiologyRow}
                          size='small'
                          variant='contained'
                          className='add-button'
                        >
                          {add}
                        </Button>
                      </TableCell>
                    </TableRow>
                  )}
                  {orderType === labConstant &&
                    rows?.map((row: any, index) => (
                      <TableRow key={index}>
                        <TableCell className='text-center col-sl-no'>
                          {index + 1}
                        </TableCell>
                        <TableCell className='text-center col-date'>
                          {new Date().toLocaleDateString()}
                        </TableCell>
                        <TableCell className='td-mode col-mode'>
                          {row?.mode?.label}
                        </TableCell>
                        {locations.pathname.startsWith(labordercreate) && (
                          <TableCell className='col-origin'>
                            {row?.origin?.label}
                          </TableCell>
                        )}
                        {locations.pathname.startsWith(labordercreate) && (
                          <TableCell className='col-requested-by'>
                            {row?.requestedBy?.value}
                          </TableCell>
                        )}
                        <TableCell className='td-test-name col-test-name'>
                          {row?.mode?.value ===
                          OPD_ORDERS_CONSTANTS.MODE_PACKAGE
                            ? row?.productName
                            : row?.testName?.label}
                        </TableCell>
                        {row?.mode?.value ===
                          OPD_ORDERS_CONSTANTS.MODE_PACKAGE && (
                          <TableCell className='col-test-name'>
                            {renderParameters(row?.panels || [])}
                          </TableCell>
                        )}
                        <TableCell className='text-center col-quantity'>
                          1
                        </TableCell>
                        <TableCell>
                          {OPD_ORDERS_CONSTANTS.CURRENCY_SYMBOL}{' '}
                          {row?.panel?.defaultPrice?.toFixed(
                            OPD_ORDERS_CONSTANTS.DECIMAL_PLACES
                          ) || OPD_ORDERS_CONSTANTS.DEFAULT_PRICE}
                        </TableCell>
                        <TableCell>
                          {row?.panel?.discount?.toFixed(
                            OPD_ORDERS_CONSTANTS.DECIMAL_PLACES
                          ) || '0.00'}
                          %
                        </TableCell>
                        <TableCell>
                          {OPD_ORDERS_CONSTANTS.CURRENCY_SYMBOL}{' '}
                          {(row?.panel?.price || 0)?.toFixed(
                            OPD_ORDERS_CONSTANTS.DECIMAL_PLACES
                          )}
                        </TableCell>
                        <TableCell>
                          <IconButton
                            size='small'
                            onClick={() => handleDeleteRow(index)}
                            className='delete-icon'
                          >
                            <DeleteOutlinedIcon fontSize='small' />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  {orderType === radiologyText &&
                    radiologyRows?.map((row: OpdRadiologyRow, index) => (
                      <TableRow key={index}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{new Date().toLocaleDateString()}</TableCell>
                        <TableCell>{radiologyModeLabel}</TableCell>
                        {locations.pathname.startsWith(labordercreate) && (
                          <TableCell className='col-origin'>
                            {row?.origin?.label}
                          </TableCell>
                        )}
                        {locations.pathname.startsWith(labordercreate) && (
                          <TableCell className='col-requested-by'>
                            {row?.requestedBy?.value}
                          </TableCell>
                        )}
                        <TableCell>
                          {row?.packageTests?.packageName ||
                            row?.testName?.label}
                        </TableCell>
                        <TableCell>1</TableCell>
                        <TableCell>
                          {OPD_ORDERS_CONSTANTS.CURRENCY_SYMBOL}{' '}
                          {(row?.defaultPrice || 0)?.toFixed(
                            OPD_ORDERS_CONSTANTS.DECIMAL_PLACES
                          )}
                        </TableCell>
                        <TableCell>
                          {(row?.discount || 0)?.toFixed(
                            OPD_ORDERS_CONSTANTS.DECIMAL_PLACES
                          )}
                          %
                        </TableCell>
                        <TableCell>
                          {OPD_ORDERS_CONSTANTS.CURRENCY_SYMBOL}{' '}
                          {(row?.price || 0)?.toFixed(
                            OPD_ORDERS_CONSTANTS.DECIMAL_PLACES
                          )}
                        </TableCell>
                        <TableCell>
                          <IconButton
                            size='small'
                            onClick={() => handleDeleteRadiologyRow(index)}
                            className='delete-icon'
                          >
                            <DeleteOutlinedIcon fontSize='small' />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>

        <div className='total-section'>
          <div className='total-info'>
            <div className='total-box'>
              <span className='total-label'>Total Tests:</span>
              <span className='total-value'>
                {orderType === labConstant
                  ? rows?.length
                  : radiologyRows?.length}
              </span>
            </div>
            <div className='total-box'>
              <span className='total-label'>Total Amount:</span>
              <span className='total-value total-amount'>
                {OPD_ORDERS_CONSTANTS.CURRENCY_SYMBOL}{' '}
                {orderType === labConstant
                  ? rows
                      ?.reduce((sum, row) => {
                        const price = row?.panel?.price || 0
                        return sum + price || 0
                      }, 0)
                      ?.toFixed(OPD_ORDERS_CONSTANTS?.DECIMAL_PLACES) ||
                    OPD_ORDERS_CONSTANTS?.DEFAULT_PRICE
                  : radiologyRows
                      ?.reduce((sum, row) => {
                        const price = row?.price || 0
                        return sum + price || 0
                      }, 0)
                      ?.toFixed(OPD_ORDERS_CONSTANTS?.DECIMAL_PLACES) ||
                    OPD_ORDERS_CONSTANTS?.DEFAULT_PRICE}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default OpdOrder
